(function () {
  'use strict';
  function initContact() {
    var form = document.getElementById('luftix-callback-form');
    if (!form || form.dataset.contactReady) return;
    form.dataset.contactReady = 'true';
    var radios = form.querySelectorAll('input[data-choice]');
    var phoneField = form.querySelector('[data-field="phone"]');
    var phoneInput = form.querySelector('#luftix-phone');
    var cards = form.querySelectorAll('[data-choice-card]');
    var button = form.querySelector('.luftix-contact__submit');
    if (!phoneField || !phoneInput || !button) return;
    var emailButtonLabel = button.textContent;
    function update() {
      var checked = form.querySelector('input[data-choice]:checked');
      var choice = checked ? checked.getAttribute('data-choice') : 'email';
      cards.forEach(function (card) {
        card.classList.toggle('is-selected', card.getAttribute('data-choice-card') === choice);
      });
      phoneField.hidden = choice !== 'phone';
      phoneInput.required = choice === 'phone';
      phoneInput.disabled = choice !== 'phone';
      button.textContent = choice === 'phone' ? 'Be om att bli uppringd' : emailButtonLabel;
    }
    radios.forEach(function (radio) { radio.addEventListener('change', update); });
    update();
  }
  initContact();
  document.addEventListener('shopify:section:load', initContact);
})();
